import styled from 'styled-components';
import shadow from '../../assets/images/shadow.png';

const StyledBgShadowImage = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	opacity: 0.5;
	background: #111314;
`;

const StyledBgShadow = styled.div`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: 1200px;
	height: 1200px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-size: contain;
`;

export { StyledBgShadow, StyledBgShadowImage };
